import React from 'react';
import PropTypes from 'prop-types';

import { NumberInputSelect } from '../../components';
const maxDropdownQuantity = 10;

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.onQuantityChange = this.props.onQuantityChange ? this.onQuantityChange.bind(this) : null;
  }

  onQuantityChange(qty) {
    if (qty > 0) {
      this.props.onQuantityChange(this.props.item.Id, Number(qty));
    } else {
      this.props.onDelete(this.props.item.Id, this.props.item.Quantity);
    }
  }

  render() {
    const item = this.props.item;
   
    return (
      <div className="media">
        <div className="pull-left">
          <img alt={item.Name} className="media-object" height="60" src={item.ImageUrl} width="40" />
        </div>
        <div className="media-header checkout-cart-item-name">
          <h4>{item.Name}</h4>
        </div>
        <div className="media-body">
          <span className="checkout-cart-item-sku" style={{ marginRight: 10 }}>
            Item Number: {item.BRPART}
          </span>
          <NumberInputSelect
            maxDropdownQuantity={maxDropdownQuantity}
            componentClassName={"checkout-cart-item-quanity"}
            quantity={this.props.item.Quantity}
            onChange={this.onQuantityChange}
            onDelete={() => this.props.onDelete(item.Id, this.props.item.Quantity)}
          />
        </div>
      </div>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    ImageUrl: PropTypes.string.isRequired,
    SKU: PropTypes.string.isRequired,
    BRPART: PropTypes.string.isRequired,
    Quantity: PropTypes.number.isRequired
  }).isRequired,
  onQuantityChange: PropTypes.func,
  onDelete: PropTypes.func
}

export default CartItem;